import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./AddLink.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyle from "../../Styleds";
import apiManager from '../../ApiManager';
const AddLink = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [value, set_value] = useState("");
    const [title, set_title] = useState("");
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);
    const inputRef = useRef(null);
    
    useEffect(() => {
        /* const interval = setInterval(() => {
            navigator.clipboard.readText()
                .then(text => {
                    console.log(text)
                })
                .catch(err => {
                    console.error('讀取剪貼簿失敗:', err);
                });
        }, 2000); */
        console.log("AddLink");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
        return () => {
            /* console.log("清除定時器");
            clearInterval(interval); */
        };
    }, [])
    useEffect(() => {
        if(value!=="")
        apiManager.fetchPost("link-query", { url: value }).then(res => {
            console.log("res", res);
            set_title(res.Title);
        }).catch(err => {
            console.log("err", err)
        })
    }, [value]);
    function updateHeight() {
        if (scrollableRef.current && maskRef.current) {
            const h = contentRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }
    function releseHand(e) {
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight * .9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                setInProp(false);
            }, 500);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }
   
    /* function checkTitle(url) {
        const urlPattern = new RegExp('^(https?:\\/\\/)?' + // 協議（http 或 https）
            '((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|' + // 網域名
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // 或 IP (v4) 地址
            '(\\:\\d+)?(\\/[-a-zA-Z0-9%_.~+]*)*' + // 端口號和路徑
            '(\\?[;&a-zA-Z0-9%_.~+=-]*)?' + // 查詢字符串
            '(\\#[-a-zA-Z0-9_]*)?$', 'i'); // 錨點

        // 檢查是否匹配 URL 格式
        const isValidUrl = urlPattern.test(url);

        if (isValidUrl) {
            apiManager.fetchPost("link-query", { url: url }).then(res => {
                console.log("res", res);
                set_title(res.Title);
            }).catch(err => {
                console.log("err", err)
            })
        } else {
        }
    } */
    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "AddLink"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                    setInProp(false);
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    {arg.type === "rewilding" &&
                                        <div className={styleUi.view} style={{ background: "#F7F6F2" }}>
                                            <YStyle.Row align="flex-start">
                                                <img src="./assets/ui/arrowLeft.png" onClick={e => { setInProp(false); }} />
                                                <YStyle.Span size={17}>新增連結</YStyle.Span>
                                            </YStyle.Row>
                                            <YStyle.Row className={styleUi.inputBox} style={{ padding: "0 2px 0 1rem", height: "2.4rem" }}>
                                                <img src="./assets/ui/link.png" />
                                                <YStyle.Input value={value} size={17} fontWeight={400} ref={inputRef} placeholder="輸入網址" onChange={e => {
                                                    set_value(e.target.value)
                                                }} />
                                                <YStyle.BTN3 /* disabled={true} */ normalBg="black" disableBg="#00000015" style={{ borderRadius: ".4rem", height: "95%", padding: ".2rem 1rem", color: "white" }} onClick={async(e) => {
                                                     const text = await navigator.clipboard.readText();
                                                     set_value(text);
                                                }} >貼上</YStyle.BTN3 >
                                            </YStyle.Row>
                                            <YStyle.Span size={13}>{`連結標題預覽：${title}`}</YStyle.Span>
                                            <YStyle.BTN3 disabled={title === ""} normalBg="black" disableBg="#00000015" style={{ width: "100%", color: "#fff", padding: ".8rem", borderRadius: ".6rem" }} onClick={e => {
                                                setInProp(false);
                                                arg.cb({ url: value, title: title });
                                            }}>
                                                <YStyle.Span size={17}>確認</YStyle.Span>
                                            </YStyle.BTN3>
                                        </div>
                                    }
                                    {arg.type === "hiking" &&
                                        <div className={styleUi.view}>
                                            <YStyle.Span size={17}>新增參考資訊連結</YStyle.Span>
                                            <YStyle.Row className={styleUi.inputBox}>
                                                <img src="./assets/ui/link.png" />
                                                <YStyle.Input size={17} fontWeight={400} placeholder="輸入網址" />
                                            </YStyle.Row>
                                            <YStyle.BTN2 style={{ width: "100%", background: "#454545", color: "#fff", padding: ".8rem" }} onClick={e => {
                                                setInProp(false);
                                            }}>
                                                <YStyle.Span size={17}>確認</YStyle.Span>
                                            </YStyle.BTN2>
                                            <YStyle.BTN2 style={{ width: "100%", background: "#F4F4F4", color: "#000", padding: ".8rem" }} onClick={e => {
                                                setInProp(false);
                                            }}>
                                                <YStyle.Span size={17}>取消</YStyle.Span>
                                            </YStyle.BTN2>
                                        </div>
                                    }
                                    {arg.type === "album" &&
                                        <div className={styleUi.view} style={{ paddingBottom: "3rem" }}>
                                            <YStyle.Span size={17}>{arg.title}</YStyle.Span>
                                            <YStyle.Row className={styleUi.inputBox}>
                                                <img src="./assets/ui/leftArrow.png" onClick={e => {
                                                    setInProp(false)
                                                }} />
                                                <YStyle.Input size={17} fontWeight={400} value={value} onChange={e=>{
                                                    set_value(e.target.value)
                                                }} ref={inputRef} placeholder="Google Photo, iCloud, flickr, Mega..." />
                                                <YStyle.BTN6><YStyle.Span color="#FFFFFF" size={17} fontWeight={400} onClick={async(e) => {
                                                     const text = await navigator.clipboard.readText();
                                                     set_value(text);
                                                }} >貼上</YStyle.Span></YStyle.BTN6>
                                            </YStyle.Row>
                                            <YStyle.BTN2 style={{ width: "100%", background: "#000000", color: "#fff", padding: ".8rem" }} onClick={e => {
                                                setInProp(false);
                                                arg.cb(value);
                                            }}>
                                                <YStyle.Span size={17} >確認</YStyle.Span>
                                            </YStyle.BTN2>
                                        </div>
                                    }
                                    {arg.type === "annketo" &&
                                        <div className={styleUi.view} style={{ paddingBottom: "3rem" }}>
                                            <YStyle.Span size={17}>新增問卷連結</YStyle.Span>
                                            <YStyle.Row className={styleUi.inputBox}>
                                                <img src="./assets/ui/leftArrow.png" onClick={e => {
                                                    setInProp(false)
                                                }} />
                                                <YStyle.Input size={17} fontWeight={400} ref={inputRef} placeholder="Google 表單, SurveyCake..." />
                                                <YStyle.BTN6><YStyle.Span color="#FFFFFF" size={17} fontWeight={400} onClick={async(e) => {
                                                     const text = await navigator.clipboard.readText();
                                                     set_value(text);
                                                }} >貼上</YStyle.Span></YStyle.BTN6>
                                            </YStyle.Row>
                                            <YStyle.BTN2 style={{ width: "100%", background: "#000000", color: "#fff", padding: ".8rem" }} onClick={e => {
                                                setInProp(false)
                                                arg.cb()
                                            }}>
                                                <YStyle.Span size={17} >確認</YStyle.Span>
                                            </YStyle.BTN2>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(AddLink);